<app-mold-dialog-form
  #formComponent
  *ngIf="afterViewLoad"
  [extraSteps]="extraSteps"
>
  <ng-template appMoldCreateDialogFormButtons let-valid>
    <button mat-raised-button mat-dialog-close class="app-btn-close">
      Cancelar
    </button>
    <button
      mat-raised-button
      [disabled]="valid || !assemblyItemsForm.valid"
      class="app-btn-save"
      (click)="closeDialog()"
    >
      Guardar
    </button>
  </ng-template>
</app-mold-dialog-form>
<ng-template #templateAssemblyItem>
  <form [formGroup]="assemblyItemsForm">
    <div formArrayName="moldItems" class="tw-w-full">
      <div
        *ngFor="let el of fieldsMoldItems.controls; let i = index"
        class="assembly-item-group"
      >
        <div [formGroupName]="i">
          <button
            mat-icon-button
            class="tw-bg-red-500 hover:tw-bg-red-400 tw-text-white"
            (click)="removeAssemblyItem(i)"
          >
            <mat-icon class="tw-text-white">delete</mat-icon>
          </button>
          <mat-form-field class="two-thirds" appearance="outline">
            <mat-label>Numero de parte</mat-label>
            <input
              type="text"
              matInput
              formControlName="item"
              [matAutocomplete]="auto"
            />
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
              <mat-option
                *ngFor="let option of el.value.options$ | async"
                [value]="option"
              >
                {{ option.title }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field appearance="outline" class="one-third">
            <mat-label>Cortes</mat-label>
            <input
              type="number"
              matInput
              formControlName="cavities"
              [min]="1"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
  <button mat-raised-button class="btn-add-item" (click)="addAssemblyItem()">
    <mat-icon class="tw-text-white">add</mat-icon>
  </button>
  <!--  <div class="tw-flex tw-w-full tw-justify-center tw-items-center tw-mt-2">-->
  <!--    <ng-container-->
  <!--      [ngTemplateOutlet]="templateStepperButtons"-->
  <!--      [ngTemplateOutletContext]="{-->
  <!--        showBefore: true,-->
  <!--        showNext: false-->
  <!--      }"-->
  <!--    ></ng-container>-->
  <!--  </div>-->
</ng-template>
